/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isSingleSelect,
  showContaimerLoader,
  showPriceValue,
  showPrecentage
} from "../Settings/Settings";
import { apiUrl, headerconfig } from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "sale/";
var moduleName = "Sale";
class Form extends Component {
  constructor(props) {
    super(props);
    var saleID = this.props.match.params?.saleID || "";
    this.state = {
      userID: userID(),
      saleID: saleID,
      currentPath: this.props.match.path,
      postdata: {
        customer: "",
        typeofsale: "",
        priviousTypeOfSale: "",
        saleinvoiceType: "",
        brandID: "",
        warranty: "",
        salePaymentTerms: "",
        saleDeliveryNote: "",
        saleBuyerOrderNo: "",
        saleBuyerOrderDate: "",
        saleTermsofDelivery: "",
        products: [
          {
            product: "",
            description: "",
            qty: "",
            price: "",
            totalPrice: "",
          },
        ],
        totalPrice: 0,
        taxAmount: 0,
        taxList:[],
        cgst:0,
        sgst:0,
        endDate: "",
      },
      detaildata: [],
      customerList: [],
      productList: [],
      brandList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadCustomer();
    this.loadBrand();
    this.loadProduct();
    if (this.state.saleID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.saleID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }

    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      typeof nextProps.detaildata !== undefined &&
      typeof nextProps.detaildata !== "undefined" &&
      this.state.editID !== ""
    ) {
      if (nextProps.detaildata.length > 0) {
        this.setState({ detaildata: nextProps.detaildata }, function () {
          if (nextProps.detaildata[0].status === "ok") {
            var result = nextProps.detaildata[0].result;
            var saleinvoiceType ='';
            
            if(result.saleinvoiceType==="1") {
              saleinvoiceType = { value: "1", label: "Tax Invoice" };
            } else if(result.saleinvoiceType==="2") { 
              saleinvoiceType =  { value: "2", label: "Delivery Challan" };
            } else if(result.saleinvoiceType==="3") { 
              saleinvoiceType =  { value: "3", label: "Proforma Invoice" };
            }
            var products_ = (result.salItem.length>0)?result.salItem:[];
            products_.push({
              product: "",
              description: "",
              qty: "",
              price: "",
              totalPrice: "",
            })
            {console.log(result.saleType, 'typeofsaletypeofsaletypeofsale')}
            var clientupdatedata = {
              customer: {
                value: result.customerID,
                customerID: result.customerID,
                customerName: result.customerName,
                customerAddress1: result.customerAddress1,
                customerAddress2: result.customerAddress2,
                customerState: result.customerState,
                customerBranch: result.customerBranch,
                customerPincode: result.customerPincode,
                customerContactPerson: result.customerContactPerson,
                customerMobile: result.customerMobile,
                customerEmail: result.customerEmail,
              },
              typeofsale: { label: result.saleType, value: result.saleType },
              priviousTypeOfSale: result.saleType,
              saleinvoiceType: saleinvoiceType,
              brandID: "",
              warranty: "",
              salePaymentTerms:
                result.salePaymentTerms !== ""
                  ? {
                      label: result.salePaymentTerms,
                      value: result.salePaymentTerms,
                    }
                  : "",
              products:products_,
              totalPrice: result.salePrice,
              taxAmount: result.saleTaxAmount,
              taxList: result.saleTaxList,
              cgst:result.cgst,
              sgst:result.sgst,
              endDate:
                result.endDate !== ""
                  ? format(new Date(result.endDate), "dd-MM-yyyy")
                  : "",
              saleDeliveryNote: result.saleDeliveryNote,
              saleBuyerOrderNo: result.saleBuyerOrderNo,
              saleBuyerOrderDate:
                result.saleBuyerOrderDate !== ""
                  ? new Date(result.saleBuyerOrderDate)
                  : "",
              saleTermsofDelivery: result.saleTermsofDelivery,
            };
            this.setState({
              postdata: clientupdatedata,
              pageloading: false,
            });
          } else {
            this.setState({ pageloading: false }, () => {
              this.props.history.push("/" + module);
              showAlert("Error", "Invalid" + moduleName, "error");
            });
          }
        });
      }
    }
  }
  loadCustomer() {
    var urlShringTxt =
      apiUrl + "customer/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ customerList: res.data.result });
      }
    });
  }
  loadProduct() {
    var urlShringTxt =
      apiUrl + "products/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ productList: res.data.result });
      }
    });
  }
  loadBrand() {
    var urlShringTxt =
      apiUrl + "brand/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ brandList: res.data.result });
      }
    });
  }

  sateValChange = (field, value) => {};

  /* signin - start*/
  fieldChange = (field, value) => {
    console.log(field, 'fieldfieldfield')
    if(field==='taxList') {
      this.setState(
        update(this.state, { postdata: { taxList: { $set: value }} })
      );
    }else {
      this.setState(
        update(this.state, { postdata: { [field]: { $set: value } } })
      );
    }
    
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    var postObject = {
      saleCutomerID: postData.customer?.value || "",
      saleType: postData.typeofsale?.value || "",
      saleinvoiceType: postData.saleinvoiceType?.value || "",
      brandID: postData.brandID?.value || "",
      warranty: postData.warranty?.value || "",
      salePaymentTerms: postData.salePaymentTerms?.value || "",
      subTotal: postData.totalPrice,
      taxAmount: postData.taxAmount,
      cgst:postData.cgst,
      sgst:postData.sgst,
      salePrice:
        parseFloat(postData.totalPrice) + parseFloat(postData.taxAmount),
      products: JSON.stringify(postData.products),
      taxList: JSON.stringify(postData.taxList),
      saleDeliveryNote: postData.saleDeliveryNote,
      saleBuyerOrderNo: postData.saleBuyerOrderNo,
      saleBuyerOrderDate:
        postData.saleBuyerOrderDate !== ""
          ? format(new Date(postData.saleBuyerOrderDate), "yyyy-MM-dd")
          : "",
      saleTermsofDelivery: postData.saleTermsofDelivery,
      userID: this.state.userID,
    };
    var post_url = module + "add";
    if (this.state.saleID !== "") {
      postObject["edit_id"] = this.state.saleID;
      post_url = module + "update";
    }
    if (this.state.currentPath === "/sale/convertsale/:saleID") {
      postObject["edit_id"] = this.state.saleID;
      post_url = module + "updatedeliverychallan";
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="sale" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/" + module}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            customerList={this.state.customerList}
                            productList={this.state.productList}
                            brandList={this.state.brandList}
                            saleID={this.state.saleID}
                            currentPath={this.state.currentPath}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { customer, salePaymentTerms } =
    props.fields;

  return {
    fields: ["customer", "salePaymentTerms"],
    validations: {
      customer: [[isSingleSelect, customer]],
      salePaymentTerms: [[isSingleSelect, salePaymentTerms]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPrice: this.props.fields.totalPrice,
      taxAmount: this.props.fields.taxAmount,
      taxList:this.props.fields.taxList,
    };
  }

  goBack() {
    this.props.history.push("/users");
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
    if (this.props.saleID !== "") {
      setTimeout(() => this.updateSelectProductNew(value.value), 1000);
    }
  }

  updateSelectProductNew = async (value) => {
    var products = this.props.fields.products;
    var updPro = [];
    var totalPrice = 0;
    var taxAmount = 0;
    var cgst = 0;
    var taxList = [];
    products.map((item) => {
      var getPrice = this.getPrice(item.product.value, value);
      var product = item.product;
      var description = item.description;
      var qty = item.qty;
      var price = getPrice;
      var totalPrice =
        parseInt(qty) > 0 && parseFloat(price) > 0
          ? qty * parseFloat(price)
          : "";
      updPro.push({
        product: product,
        description: description,
        qty: qty,
        price: price,
        totalPrice: totalPrice,
      });
    });
    var lastQtyVal = "";
    updPro.map((item, index) => {
      if (item.totalPrice !== "") {
        totalPrice += parseFloat(item.totalPrice);
        if (parseFloat(item.product.productTax) > 0) {
          if((this.props.fields.customer?.customerState).toLowerCase()!=="karnataka") {
            taxAmount += parseFloat(item.totalPrice) * ((item.product.productTax / 100));
          }else {
            taxAmount += parseFloat(item.totalPrice) * (2 * (item.product.productTax / 100));
          }
          var cgst=  parseFloat(item.totalPrice) * ((item.product.productTax / 100));
          const foundIndex = taxList.findIndex(titem => titem.taxpercentage === item.product.productTax);
          if(foundIndex>=0) {
            var existTax = taxList[foundIndex];
            var existCGST = existTax.cgst;
            var newCGST = (parseFloat(existCGST) + parseFloat(cgst)).toFixed('2');
            if((this.props.fields.customer?.customerState).toLowerCase()!=="karnataka") {
              var updatedTax = {taxpercentage:item.product.productTax, cgst:newCGST}
            }else {
              var updatedTax = {taxpercentage:item.product.productTax, cgst:cgst, sgst:cgst}
            }            
            taxList[foundIndex] = updatedTax;
          }else {
            if((this.props.fields.customer?.customerState).toLowerCase()!=="karnataka") {
              taxList.push({taxpercentage:item.product.productTax, cgst:cgst})
            }else {
              taxList.push({taxpercentage:item.product.productTax, cgst:cgst, sgst:cgst})
            }            
          }
        }
      }
      if (
        item.qty !== "" &&
        item.product !== "" &&
        updPro.length === parseInt(index) + 1
      ) {
        lastQtyVal = "Yes";
      }
    });
    this.props.onChange("products", updPro);
    this.setState({ totalPrice: totalPrice, taxAmount: taxAmount, taxList:taxList }, () => {
      this.props.onChange("totalPrice", totalPrice);
      setTimeout(() => {
        this.props.onChange("taxAmount", taxAmount);
        setTimeout(() => {  this.props.onChange("taxList", taxList)} , 1000);
      } , 2000);
    });
  };
  getPrice(productID, type) {
    var price = 0;

    if (this.props.productList.length > 0) {
      this.props.productList.map((item) => {
        if (item.value === productID) {
          if (type === "AMC") {
            price = item.amcPrice;
          } else if (type === "CMC") {
            price = item.cmcPrice;
          } else {
            price = item.productPrice;
          }
        }
      });
    }

    return price;
  }
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeDate(name, value) {
    this.props.onChange(name, value);
  }

  handleSelectProChange(updIndex, name, value) {
    this.updateSelectProduct(updIndex, name, value);
  }
  handleChangeText(updIndex, name, e) {
    this.updateSelectProduct(updIndex, name, e.target.value);
  }
  updateSelectProduct(updIndex, name, value) {
    var products = this.props.fields.products;
    var updPro = [];
    var totalPrice = 0;

    products.map((item, index) => {
      if (index === updIndex) {
        var product = name === "product" ? value : item.product;
        var description = name === "description" ? value : item.description;
        var qty = name === "qty" ? value : item.qty;
        var price = "";
        if (name === "product") {
          if (this.props.fields.typeofsale?.value === "AMC") {
            price = product?.amcPrice;
          } else if (this.props.fields.typeofsale?.value === "CMC") {
            price = product?.cmcPrice;
          } else {
            price = product?.productPrice;
          }
        } else {
          price = name === "price" ? value : item.price;
        }

        var totalPrice =
          parseInt(qty) > 0 && parseFloat(price) > 0
            ? qty * parseFloat(price)
            : "";
        updPro.push({
          product: product,
          description: description,
          qty: qty,
          price: price,
          totalPrice: totalPrice,
        });
      } else {
        updPro.push(item);
      }
    });
    var lastQtyVal = "";
    var taxAmount = 0;
    //var cgst = 0;

    var taxList = [];

    updPro.map((item, index) => {
      if (item.totalPrice !== "") {
        totalPrice += parseFloat(item.totalPrice);
        if (parseFloat(item.product.productTax) > 0) {
          if((this.props.fields.customer?.customerState).toLowerCase()!=="karnataka") {
            taxAmount += parseFloat(item.totalPrice) * ((item.product.productTax / 100));
          }else {
            taxAmount += parseFloat(item.totalPrice) * (2 * (item.product.productTax / 100));
          }
          var cgst=  parseFloat(item.totalPrice) * ((item.product.productTax / 100));
          const foundIndex = taxList.findIndex(titem => titem.taxpercentage === item.product.productTax);
          if(foundIndex>=0) {
            var existTax = taxList[foundIndex];
            var existCGST = existTax.cgst;
            var newCGST = (parseFloat(existCGST) + parseFloat(cgst)).toFixed('2');
            if((this.props.fields.customer?.customerState).toLowerCase()!=="karnataka") {
              var updatedTax = {taxpercentage:item.product.productTax, cgst:newCGST}
            }else {
              var updatedTax = {taxpercentage:item.product.productTax, cgst:cgst, sgst:cgst}
            }            
            taxList[foundIndex] = updatedTax;
          }else {
            if((this.props.fields.customer?.customerState).toLowerCase()!=="karnataka") {
              taxList.push({taxpercentage:item.product.productTax, cgst:cgst})
            }else {
              taxList.push({taxpercentage:item.product.productTax, cgst:cgst, sgst:cgst})
            }            
          }

        }
      }
      if (
        item.qty !== "" &&
        item.product !== "" &&
        updPro.length === parseInt(index) + 1
      ) {
        lastQtyVal = "Yes";
      }
    });
    if (lastQtyVal === "Yes") {
      updPro.push({
        product: "",
        description: "",
        qty: "",
        price: "",
        totalPrice: "",
      });
    }
    this.props.onChange("products", updPro);
    this.setState({ totalPrice: totalPrice, taxAmount: taxAmount, taxList:taxList }, () => {
      this.props.onChange("totalPrice", totalPrice);
      setTimeout(() => {
        this.props.onChange("taxAmount", taxAmount);
        setTimeout(() => {  this.props.onChange("taxList", taxList)} , 1000);
      } , 2000);
    });
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgcustomer,
      errMsgtsalePaymentTerms = "";

    if ($validation.customer.error.reason !== undefined) {
      errMsgcustomer = $validation.customer.show && (
        <span className="error">{$validation.customer.error.reason}</span>
      );
    } 

    if ($validation.salePaymentTerms.error.reason !== undefined) {
      errMsgtsalePaymentTerms = $validation.salePaymentTerms.show && (
        <span className="error">
          {$validation.salePaymentTerms.error.reason}
        </span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            {this.props.saleID === "" && (
              <div className="form-group col-md-4">
                <label className="form-label">
                  Customer<span className="lbl-error">*</span>
                </label>
               
                <Select
                  value={fields.customer}
                  onChange={this.handleSelectChange.bind(this, "customer")}
                  placeholder="Select Customer"
                  isClearable={true}
                  options={this.props.customerList}
                />
                {errMsgcustomer}
              </div>
            )}
            <div className="form-group col-md-3">
              <label className="form-label">
                Payment Terms<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.salePaymentTerms}
                onChange={this.handleSelectChange.bind(
                  this,
                  "salePaymentTerms"
                )}
                placeholder="Select Type Of Sale"
                isClearable={true}
                options={[
                  { value: "With in a week", label: "With in a week" },
                  { value: "Immediate", label: "Immediate" },
                  { value: "30 Day Cridit", label: "30 Day Cridit" },
                ]}
              />
              {errMsgtsalePaymentTerms}
            </div>

            {fields.typeofsale?.value === "Hardware" && (
              <div className="form-group col-md-3">
                <label className="form-label">
                  Brand<span className="lbl-error">*</span>
                </label>
                <Select
                  value={fields.brandID}
                  onChange={this.handleSelectChange.bind(this, "brandID")}
                  placeholder="Select Brand"
                  isClearable={true}
                  options={this.props.brandList}
                />
              </div>
            )}
            {fields.typeofsale?.value === "Hardware" && (
              <div className="form-group col-md-3">
                <label className="form-label">
                  Warranty<span className="lbl-error">*</span>
                </label>
                <Select
                  value={fields.warranty}
                  onChange={this.handleSelectChange.bind(this, "warranty")}
                  placeholder="Select Brand"
                  isClearable={true}
                  options={[
                    {
                      label: "6 Month",
                      value: "6 Month",
                    },
                    {
                      label: "1 Year",
                      value: "1 Year",
                    },
                    {
                      label: "2 Year",
                      value: "2 Year",
                    },                    
                    {
                      label: "4 Year",
                      value: "4 Year",
                    },
                    {
                      label: "5 Year",
                      value: "5 Year",
                    },
                  ]}
                />
              </div>
            )}
            <div className="form-group col-md-3">
              <label className="form-label">Delivery Note</label>
              <input
                type="text"
                className="form-control"
                placeholder="Machine No"
                name="Delivery Note"
                value={fields.saleDeliveryNote}
                {...$field("saleDeliveryNote", (e) =>
                  onChange("saleDeliveryNote", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Buyer Order No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Machine No"
                name="Buyer Order No."
                value={fields.saleBuyerOrderNo}
                {...$field("saleBuyerOrderNo", (e) =>
                  onChange("saleBuyerOrderNo", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Buyer Order Date</label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.saleBuyerOrderDate}
                dateFormat="dd-MM-yyyy"
                placeholderText="Buyer Order Date"
                onChange={this.handleChangeDate.bind(
                  this,
                  "saleBuyerOrderDate"
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Terms of Delivery</label>
              <textarea
                className="form-control"
                placeholder="Terms of Delivery"
                name="saleTermsofDelivery"
                {...$field("saleTermsofDelivery", (e) =>
                  onChange("saleTermsofDelivery", e.target.value)
                )}
                rows="3"
                defaultValue={fields.saleTermsofDelivery}
              />
            </div>
          </div>
          {fields.endDate !== "" && (
            <div className="row pt-5">
              <div className="col-lg-6">
                <p className="h4">Expiry Date:</p>
                <div className="expiry-error">
                  <b>{fields.endDate}</b>
                </div>
              </div>
            </div>
          )}
          {fields.customer !== "" && (
            <div className="row pt-5">
              <div className="col-lg-6">
                <p className="h3">Sale To:</p>
                <p className="fs-18 fw-semibold mb-0">
                  {fields.customer?.label}
                </p>
                <address>
                  {fields.customer?.customerAddress1},{" "}
                  {fields.customer?.customerAddress2}, <br />{" "}
                  {fields.customer?.customerState} -{" "}
                  {fields.customer?.customerPincode}
                  <br />
                  Branch: {fields.customer?.customerBranch}
                  <br />
                  Contact Person:{fields.customer?.customerContactPerson}
                  <br />
                  {fields.customer?.customerMobile}
                  <br /> {fields.customer?.customerEmail}
                </address>
              </div>
              <div className="col-lg-6 text-end"></div>
            </div>
          )}
          <div className="push">
            <table className="table table-bordered table-hover mb-0 text-nowrap">
              <tbody>
                <tr>
                  <th className="text-center"></th>
                  <th style={{ width: "40%" }}>Item</th>
                  <th className="text-center">Description</th>
                  <th className="text-center">Quantity</th>
                  {(fields.saleinvoiceType === "" ||
                    fields.saleinvoiceType?.value == "1" || fields.saleinvoiceType?.value == "3") && (
                    <>
                      <th className="text-end">Unit Price</th>
                      <th className="text-end">Sub Total</th>
                    </>
                  )}
                </tr>
                {fields.products.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">{parseInt(index) + 1}</td>
                      <td>                        
                        <Select
                          value={item.product}
                          onChange={this.handleSelectProChange.bind(
                            this,
                            index,
                            "product"
                          )}
                          placeholder="Select Product"
                          isClearable={true}
                          options={this.props.productList}
                          />                       
                      </td>
                      <td className="text-center">
                        <textarea
                          className="form-control"
                          placeholder="Description"
                          onChange={this.handleChangeText.bind(
                            this,
                            index,
                            "description"
                          )}
                          rows="3"
                          defaultValue={item.description}
                        />
                      </td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Qty"
                          name="qty"
                          value={item.qty}
                          autoComplete="off"
                          onChange={this.handleChangeText.bind(
                            this,
                            index,
                            "qty"
                          )}
                          maxLength={6}
                        />
                      </td>
                      {(fields.saleinvoiceType === "" ||
                        fields.saleinvoiceType?.value == "1" || fields.saleinvoiceType?.value == "3") && (
                        <>
                          <td className="text-end">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Price"
                              autoComplete="off"
                              name="price"
                              value={item.price}
                              onChange={this.handleChangeText.bind(
                                this,
                                index,
                                "price"
                              )}
                            />
                          </td>
                          <td className="text-end">
                            {showPriceValue(item.totalPrice)}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
                {(fields.saleinvoiceType === "" ||
                  fields.saleinvoiceType?.value == "1" || fields.saleinvoiceType?.value == "3") && (
                  <>
                    <tr>
                      <td
                        colSpan="5"
                        className="fw-bold text-uppercase text-end"
                      >
                        Sub Total
                      </td>
                      <td className="fw-bold text-end h4">
                        {showPriceValue(this.state.totalPrice)}
                      </td>
                    </tr>
                    {this.state.taxList.length>0 &&(
                      this.state.taxList.map((item, index)=> {
                        return (
                          <React.Fragment key={index}>
                            {(fields.customer?.customerState).toLowerCase()==="karnataka" && (
                            <tr>
                              <td
                                colSpan="5"
                                className="fw-bold text-uppercase text-end"
                              >
                                SGST({showPrecentage(item.taxpercentage)}%)
                              </td>
                              <td className="fw-bold text-end h4">
                                {showPriceValue(item.sgst)}
                              </td>
                            </tr>)}
                            <tr>
                              <td
                                colSpan="5"
                                className="fw-bold text-uppercase text-end"
                              >
                                CGST({showPrecentage(item.taxpercentage)}%)
                              </td>
                              <td className="fw-bold text-end h4">
                                {showPriceValue(item.cgst)}
                              </td>
                            </tr>
                          </React.Fragment>
                        )
                      })
                    )}
                    <tr>
                      <td
                        colSpan="5"
                        className="fw-bold text-uppercase text-end"
                      >
                        Grand Total
                      </td>
                      <td className="fw-bold text-end h4">
                        {showPriceValue(
                          parseFloat(this.state.totalPrice) +
                            parseFloat(this.state.taxAmount)
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Modify Sale
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
